import { url } from "./MongoConstants";

const getExchange = async () => {
    try {
        const server = url;
        const response = await fetch(server + '/api/data/exchange', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (response.ok) {
            const data = await response.json();
            return data.data; // Return only the data array, not the whole response
        } else {
            console.log('Failed to get teams');
            return [];
        }
    } catch (error) {
        console.error('An error occurred:', error);
        return [];
    }
};

export default getExchange;